import { IEnquiry } from '@wot/typings';
import { BiSort } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { Table, TableBody, TableHeading, TableHeadingCol, TableRow } from '../../../../components/Table';
import TableRowItem from './TableRowItem';

interface Props {
  data: IEnquiry[];
  handleSort: (key: 'createdAt' | 'name') => void;
}

export default function TableContainer({ data, handleSort }: Props) {
  const navigate = useNavigate();
  return (
    <Table>
      <TableHeading>
        <TableRow>
          <TableHeadingCol
            label="DATE"
            component={
              <div className="flex items-center">
                <p className="">DATE</p>
                <BiSort className="text-sm" />
              </div>
            }
            onClick={() => handleSort('createdAt')}
          />
          <TableHeadingCol label="Class ID" />
          <TableHeadingCol
            label="NAME"
            component={
              <div className="flex items-center">
                <p className="">NAME</p>
                <BiSort className="text-sm" />
              </div>
            }
            onClick={() => handleSort('name')}
          />
          <TableHeadingCol label="Subject" />
          <TableHeadingCol label="Email" />
          <TableHeadingCol label="STATUS" />
        </TableRow>
      </TableHeading>
      <TableBody>
        {data.map((enquiry) => (
          <TableRow key={enquiry._id} onClick={() => navigate(enquiry._id)}>
            <TableRowItem enquiry={enquiry} />
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
}
